/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 4v6h-2V7.412L15.413 12 20 16.587V14h2v6h-6v-2h2.587l-5-5H2v-2h11.586l5-5H16V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgIf as If };
